export default "/pt-usdc.479eb5edfa7fac246813b2c15509ceb9.svg";